import AppLayout from "../components/layout/AppLayout";
import DocumentTableComponent from "../components/document/DocumentTableComponent";

export default function Document() {
  return (
    <AppLayout>
      <DocumentTableComponent />
    </AppLayout>
  );
}
